// Tile layout
export const GRID_SPACING = 2;
export const QUICK_LINKS_PER_COL = 2;
